<template>
  <div class="page event-management">
    <management-nav @save="saveTicketsToEvent"></management-nav>
    <side-menu activeNav="Event" childName="Tickets"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading title="Tickets"></heading>

        <div class="btns">
          <button @click="openTicketPopup" class="btn">
            <img class="white_icon" src="@/assets/img/plus.svg" />
            Add Ticket
          </button>
        </div>

        <popup title="Add An Agenda" :show="showPopup">
          <div class="input">
            <p>Event Start Date: {{ event.start_time | format_date_time }}</p>
            <p>
              Event End Date:
              {{ event.end_time | format_date_time }}
            </p>
          </div>
          <div class="btns">
            <button @click="addTicket('free')" class="btn">
              <img class="white_icon" src="@/assets/img/plus.svg" />Free Ticket
            </button>
            <button @click="addTicket('paid')" class="btn">
              <img class="white_icon" src="@/assets/img/plus.svg" />Paid Ticket
            </button>
            <!-- <button @click="addTicket('donate')" class="btn">
                  <img class="white_icon" src="@/assets/img/plus.svg" />Donation
                  Ticket
                </button> -->
          </div>
          <div v-if="ticket" class="inputs">
            <div class="input">
              <label
                >Ticket Name
                <span class="required">*</span>
              </label>
              <input v-model="ticket.name" type="text" />
            </div>
            <div class="input">
              <label
                >Venue
                <span class="required">*</span>
              </label>
              <v-select
                v-model="selectedVenue"
                label="name"
                :options="venues"
              ></v-select>
            </div>
            <div class="input" v-if="selectedVenue">
              <label>Select an Area <span class="required">*</span> </label>
              <v-select
                label="name"
                v-model="selectedArea"
                :options="selectedVenue.areas"
              >
              </v-select>
            </div>
            <div v-if="selectedVenue" class="input"></div>
            <div class="input">
              <label
                >Start Date

                <span class="required">*</span>
              </label>
              <v-select
                label="label"
                :reduce="(d) => d.timestamp"
                v-model="start_date"
                :options="eventDates"
              >
              </v-select>
            </div>
            <div class="input">
              <label
                >Start Time

                <span class="required">*</span>
              </label>
              <input
                @click="$refs.start_time.isOpen = true"
                type="text"
                readonly
                :value="start_time"
              />
              <datetime
                hidden
                ref="start_time"
                type="time"
                use12-hour
                v-model="ticket.start_time"
              ></datetime>
            </div>
            <div class="input">
              <label
                >End Date

                <span class="required">*</span>
              </label>
              <v-select
                label="label"
                :reduce="(d) => d.timestamp"
                v-model="end_date"
                :options="eventDates"
              >
              </v-select>
            </div>
            <div class="input">
              <label
                >End Time
                <span class="required">*</span>
              </label>
              <input
                @click="$refs.end_time.isOpen = true"
                type="text"
                readonly
                :value="end_time"
              />
              <datetime
                hidden
                ref="end_time"
                type="time"
                use12-hour
                v-model="ticket.end_time"
              ></datetime>
            </div>
            <div class="input">
              <label>Quantity</label>
              <input
                type="number"
                placeholder="0"
                min="1"
                @change="handleNumberInput(ticket)"
                v-model.number="ticket.quantity"
              />
            </div>
            <div v-if="ticket.type !== 'free'" class="input">
              <label>Price</label>
              <input
                type="number"
                class="price"
                v-model.number="ticket.price"
              />
            </div>
            <div class="input">
              <label
                >Description
                <span class="required">*</span>
              </label>
              <textarea v-model="ticket.description" draggable="no"></textarea>
            </div>
          </div>

          <div class="btns">
            <button @click="closePopup" class="btn text_btn">Cancel</button>
            <button v-if="ticket" @click="validation" class="btn">Save</button>
          </div>
        </popup>

        <table v-if="tickets.length">
          <thead>
            <td>Ticket Name</td>
            <td>Venue/Area</td>
            <td>Start Date & Time</td>
            <td>End Date & Time</td>
            <td>Quantity Available</td>
            <td>Tickets Sold</td>
            <td>Price</td>
            <td>Action</td>
          </thead>

          <tbody>
            <tr v-for="(ticket, index) in tickets" :key="index">
              <td data-label="Ticket Name">
                <input
                  type="text"
                  placeholder="i.e Early Bird"
                  v-model="ticket.name"
                />
              </td>
              <td data-label="Ticket Name">
                {{ ticket.venue.name }} / {{ ticket.venue.area }}
              </td>
              <td data-label="Ticket Name">
                {{ ticket.start_date | format_date }} @
                {{ ticket.start_time | format_time }}
              </td>
              <td data-label="Ticket Name">
                {{ ticket.end_date | format_date }} @
                {{ ticket.end_time | format_time }}
              </td>
              <td data-label="Quantity Available">
                <input
                  type="number"
                  placeholder="0"
                  min="1"
                  @change="handleNumberInput(ticket)"
                  v-model.number="ticket.quantity"
                />
              </td>
              <td data-label="Ticket Sold">
                <p>{{ ticket.amount_sold }}/{{ ticket.quantity }}</p>
              </td>
              <td data-label="Price">
                <template v-if="ticket.type == 'paid'">
                  <p class="price_tag">$</p>
                  <input
                    type="number"
                    class="price"
                    v-model.number="ticket.price"
                  />
                </template>
                <p v-if="ticket.type == 'free'">Free</p>
                <p v-if="ticket.type == 'donate'">Donation</p>
              </td>
              <td data-label="Action">
                <img
                  class="trash"
                  @click="deleteTicket(ticket)"
                  src="@/assets/img/trash.svg"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tix_error" v-if="!tickets.length">
          <p>No tickets have been added.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import { Datetime } from "vue-datetime";
import Title from "@/components/Title.vue";
import Swal from "sweetalert2";
import Popup from "@/components/Popup.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
    popup: Popup,
    datetime: Datetime,
  },
  data() {
    return {
      event: {},
      showPopup: false,
      selectedVenue: null,
      selectedArea: null,
      start_date: null,
      end_date: null,
      tickets: [],
      ticket: null,
      venues: [],
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      venues: db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues"),
    };
  },
  created() {
    this.getAllTickets();
  },
  computed: {
    start_time: {
      get() {
        return this.ticket.start_time
          ? moment(this.ticket.start_time).format("hh:mm a")
          : null;
      },
      set(timestring) {
        this.ticket.start_time = new Date(timestring).valueOf();
      },
    },
    end_time: {
      get() {
        return this.ticket.end_time
          ? moment(this.ticket.end_time).format("hh:mm a")
          : null;
      },
      set(timestring) {
        this.ticket.end_time = new Date(timestring).valueOf();
      },
    },
    eventDates() {
      var getDaysArray = function (start, end) {
        for (
          var arr = [], dt = new Date(start);
          dt <= end;
          dt.setDate(dt.getDate() + 1)
        ) {
          let date = Object.assign({
            label: moment(new Date(dt)).format("MMMM Do YYYY"),
            timestamp: dt.getTime(),
          });
          arr.push(date);
        }
        return arr;
      };
      let start = this.event.start_time;
      let end = this.event.end_time;
      return getDaysArray(start, end);
    },
  },
  methods: {
    validation() {
      let valid = true;
      let ticket = this.ticket;
      valid = Boolean(
        ticket.name &&
          ticket.venue &&
          ticket.description &&
          ticket.start_date &&
          ticket.start_time &&
          ticket.end_date &&
          ticket.end_time
      );

      if (valid) {
        this.saveTicketToEvent();
      } else {
        return Swal.fire("", "Please fill in all required fields (*)", "info");
      }
    },

    openTicketPopup() {
      this.showPopup = true;
    },
    handleNumberInput(ticket) {
      if (ticket.quantity < 0) {
        ticket.quantity = ticket.quantity * -1;
      }
    },
    getAllTickets() {
      this.$bind(
        "tickets",
        db.collection("event").doc(this.$route.params.id).collection("ticket")
      );
    },
    async addTicket(type) {
      let new_ticket_id = await db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .doc().id;

      let ticket = {
        name: null,
        venue: null,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        description: type,
        ticket_id: new_ticket_id,
        type: type,
        accept_donation: type == "donate" ? true : false,
        amount_available: 0,
        price: 0,
        amount_sold: 0,
      };
      this.ticket = ticket;
    },
    saveTicketToEvent() {
      let ticket = this.ticket;
      ticket.amount_available = ticket.quantity;
      let ref = db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket")
        .doc(ticket.ticket_id)
        .set(ticket, { merge: true })
        .then(() => {
          return Swal.fire(
            "Update Successful",
            "Ticket has been saved",
            "success"
          ).then(() => {
            this.closePopup();
            this.getAllTickets();
          });
        })
        .catch((err) => {
          Swal.fire(
            "ERROR",
            "Something went wrong! Please try again later " + err.message,
            "error"
          );
        });
    },
    saveTicketsToEvent() {
      let last_index = this.tickets.length - 1;
      let batch = db.batch();
      this.tickets.forEach(async (ticket, index) => {
        ticket.amount_available = ticket.quantity;
        let ref = db
          .collection("event")
          .doc(this.$route.params.id)
          .collection("ticket")
          .doc(ticket.ticket_id);
        await batch.set(ref, ticket, { merge: true });

        if (index == last_index) {
          await batch
            .commit()
            .then(() => {
              this.getAllTickets();
            })
            .then(() => {
              Swal.fire(
                "Update Successful",
                "Tickets has been saved and updated",
                "success"
              );
            })
            .catch((err) => {
              Swal.fire(
                "ERROR",
                "Something went wrong! Please try again later " + err.message,
                "error"
              );
            });
        }
      });
    },
    closePopup() {
      this.showPopup = false;
      this.init_edit = false;
      this.selectedVenue = null;
      this.selectedArea = null;
      this.start_date = null;
      this.session = {};
      this.ticket = null;
    },
    formatPrice(event, ticket) {
      let val = event.target.value;
      ticket.price = val;
    },
    deleteTicket(ticket) {
      return Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("ticket")
            .doc(ticket.ticket_id)
            .delete();

          this.tickets = this.tickets.filter(
            (t, i) => t.ticket_id !== ticket.ticket_id
          );
        }
      });
    },
  },
  watch: {
    start_date(val) {
      if (!isNaN(val)) {
        this.ticket.start_date = val;
      }
    },
    end_date(val) {
      if (!isNaN(val)) {
        this.ticket.end_date = val;
      }
    },
    selectedArea(val) {
      let venue = Object.assign({}, this.selectedVenue);
      delete venue.areas;
      venue.area = val;
      this.ticket.venue = venue;
    },
  },
};
</script>

<style lang="scss"></style>
